// extracted by mini-css-extract-plugin
module.exports = {"Legend":"Legend__8GCVk"};